import { Plus, X } from "lucide-react";
import { AirportField } from "@/components/experience/AirportField";
import { RouteMap } from "@/components/experience/RouteMap";

const MAX_STOPS = 4;
const blank = () => ({ label: "", ll: "", date: "" });

export const routeOf = (stay) => (stay.route?.length >= 2 ? stay.route
  : [{ label: stay.specs?.from || "", ll: stay.specs?.from_ll || "", date: "" }, { label: stay.specs?.to || "", ll: stay.specs?.to_ll || "", date: "" }]);

const pointId = (i, n, index) => (i === 0 ? `stay-spec-from-${index}` : i === n - 1 ? `stay-spec-to-${index}` : `stay-spec-stop${i}-${index}`);

export const RouteEditor = ({ stay, index, onChange }) => {
  const route = routeOf(stay);
  const n = route.length;
  const save = (next) => onChange({ ...stay, route: next,
    specs: { ...stay.specs, from: next[0].label, from_ll: next[0].ll, to: next[next.length - 1].label, to_ll: next[next.length - 1].ll } });
  const set = (i, patch) => save(route.map((p, j) => (j === i ? { ...p, ...patch } : p)));
  return (
    <div className="space-y-3" data-testid={`stay-route-editor-${index}`}>
      <p className="field-label">Route <span className="font-normal text-muted-foreground">(add stops for multi-leg trips)</span></p>
      {route.map((p, i) => (
        <div key={i} className="grid grid-cols-[1fr_auto] items-end gap-2 sm:grid-cols-[1fr_170px_44px]">
          <AirportField label={i === 0 ? "From" : i === n - 1 ? "To" : `Stop ${i}`} value={p.label} placeholder={i === 0 ? "Nice or NCE" : i === n - 1 ? "Dubai or DXB" : "Mykonos or JMK"}
            testId={pointId(i, n, index)} onPick={(label, ll) => set(i, { label, ll })} />
          {i < n - 1 ? (
            <label className="block"><span className="field-label">Departs <span className="font-normal text-muted-foreground">(optional)</span></span>
              <input type="date" className="field" value={p.date || ""} onChange={(e) => set(i, { date: e.target.value })} data-testid={`stay-route-date-${i}-${index}`} /></label>
          ) : <span className="hidden sm:block" />}
          {i > 0 && i < n - 1 ? (
            <button type="button" className="btn-outline h-12 w-11 px-0" aria-label={`Remove stop ${i}`} onClick={() => save(route.filter((_, j) => j !== i))} data-testid={`stay-route-remove-${i}-${index}`}><X className="h-4 w-4" /></button>
          ) : <span className="hidden sm:block" />}
        </div>
      ))}
      {n - 2 < MAX_STOPS && <button type="button" className="chip" onClick={() => save([...route.slice(0, -1), blank(), route[n - 1]])} data-testid={`stay-route-add-stop-${index}`}><Plus className="h-3.5 w-3.5" /> Add a stop</button>}
      <RouteMap points={route} testId={`stay-route-map-edit-${index}`} />
    </div>
  );
};
